import Swiper from 'swiper';
const ClientsSlider = {

    init() {
        if ($('.jsClients').length > 0) {
            this.initSlider();
        }
    },
    initSlider() {
        new Swiper($('.jsSwiper.jsClients')[0], {
            autoplay: {
                delay: 1,   
            },
            slidesPerView: 8,
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 3,
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 3,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 6,
                },
                1560: {
                    slidesPerView: 8,
                },
            },
            loop: true,
            speed: 5000,
            preventInteractionOnTransition: true,
            disableOnInteraction: true,
            // freeMode: true,
            observer: true,
            observeParents: true,
        });
    },
}
export default ClientsSlider;


// WEBPACK FOOTER //
// ./scripts/modules/components/_clients-slider.js